var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"dbdeca0d21c0e7dd3ebce52f2691f7029a807920"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["health-data-management@krumware-llc"]={id:"dbdeca0d21c0e7dd3ebce52f2691f7029a807920"};
      